module.exports = new __parcel__URL__("shop_army_button_inactive.3f70090e.png").toString();